<template>
	<div class="is-flex is-flex-direction-column is-justify-content-space-between cam-assumptions">
		<div>
			<h3 class="title is-3 mb-3">Change assumptions</h3>

			<div>
				<div class="columns is-variable is-2-mobile is-4-tablet">
					<div class="column">
						<div class="field">
							<label class="label mb-1" for="cam-volume-input">
								Tickets completed a month
							</label>
							<div class="control">
								<input
									id="cam-volume-input"
									ref="volumeInput"
									class="input"
									type="number"
									min="0"
									step="1"
									inputmode="numeric"
									:value="volume"
									@input="onVolumeInput"
								/>
							</div>
						</div>
					</div>

					<div class="column">
						<div class="field">
							<label class="label mb-1" for="cam-hours-input">
								Hours each ticket takes today
							</label>
							<div class="control">
								<input
									id="cam-hours-input"
									class="input"
									type="number"
									min="0"
									step="0.5"
									inputmode="decimal"
									:value="hours"
									@input="onHoursInput"
								/>
							</div>
						</div>
					</div>
				</div>

				<p class="is-size-7 has-text-grey mt-2 mb-0">
					Typical team numbers come from typical Pipelines use by paying Gearset teams in August and September 2026.
				</p>
			</div>
		</div>

		<div class="mt-4 has-text-right">
			<button
				type="button"
				class="button is-blue"
				@click="$emit('close')"
			>
				Okay
			</button>
		</div>
	</div>
</template>

<script>

export default {
	emits: ['close'],

	computed: {
		volume() {
			return this.$store.volume;
		},

		hours() {
			return this.$store.hours;
		},
	},

	methods: {
		focusFirstField() {
			this.$refs.volumeInput.focus();
		},

		onVolumeInput(event) {
			const parsed = Number.parseFloat(event.target.value);
			this.$store.volume = Number.isFinite(parsed) && parsed >= 0 ? Math.round(parsed) : 0;
		},

		onHoursInput(event) {
			const parsed = Number.parseFloat(event.target.value);
			this.$store.hours = Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
		},
	},
};

</script>

<style lang="scss" scoped>
.cam-assumptions {
	height: 100%;

	.input {
		font-variant-numeric: tabular-nums;
	}
}

</style>
